import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {IPaginatedResponse} from "../../../request/IPaginatedResponse";

const districtRegionsByParentApiLink = apiV2ListLink.region.list(Scenario.REGION_REPORT_PRICE);

export const getDistrictRegionsByParentApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getDistrictRegionsByParent: build.query<IRegionReportPrice[], number>({
            query: (parentRegionId) => ({
                url: districtRegionsByParentApiLink,
                params: {parent: parentRegionId}
            }),
            transformResponse: (response: IPaginatedResponse<IRegionReportPrice>) => response.results
        })
    })
});

export const {useGetDistrictRegionsByParentQuery} = getDistrictRegionsByParentApi;
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {IPaginatedResponse} from "../../../request/IPaginatedResponse";

const districtRegionsByParentApiLink = apiV2ListLink.region.list(Scenario.REGION_REPORT_PRICE);

export const getDistrictRegionsByParentApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getDistrictRegionsByParent: build.query<IRegionReportPrice[], number>({
            query: (parentRegionId) => ({
                url: districtRegionsByParentApiLink,
                params: {parent: parentRegionId}
            }),
            transformResponse: (response: IPaginatedResponse<IRegionReportPrice>) => response.results
        })
    })
});

export const {useGetDistrictRegionsByParentQuery} = getDistrictRegionsByParentApi;
